import { render, staticRenderFns } from "./NotificationContainer.vue?vue&type=template&id=a0f4a06e&scoped=true"
import script from "./NotificationContainer.vue?vue&type=script&lang=js"
export * from "./NotificationContainer.vue?vue&type=script&lang=js"
import style0 from "./NotificationContainer.vue?vue&type=style&index=0&id=a0f4a06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f4a06e",
  null
  
)

export default component.exports